import { gql } from '@apollo/client';

import TRANSACTION_PRICES_FRAGMENT from './transactionPrices';
import TRANSACTION_TYPES_USER_PRICE_FRAGMENT from './userPrice';

const TRANSACTION_TYPES_FRAGMENT = gql`
  ${TRANSACTION_PRICES_FRAGMENT}
  fragment TransactionTypesFragment on TransactionType {
    id
    description
    name
    configs
    defaultPrice {
      ...TransactionPricesFragment
    }
    allUserPrice {
      id
      priceInPerson
      priceRON
      company {
        avatar {
          id
          thumbnailPipeFrom
        }
        id
        name
      }
    }
  }
`;

export const TRANSACTION_TYPES_WITH_PERSONAL_PRICE_FRAGMENT = gql`
  ${TRANSACTION_PRICES_FRAGMENT}
  ${TRANSACTION_TYPES_USER_PRICE_FRAGMENT}
  fragment TransactionTypesWithPersonalPriceFragment on TransactionType {
    id
    description
    name
    configs
    defaultPrice {
      ...TransactionPricesFragment
    }
    allUserPrice {
      id
      priceInPerson
      priceRON
      company {
        avatar {
          id
          thumbnailPipeFrom
        }
        id
        name
      }
    }
    ...TransactionTypesUserPriceFragment
  }
`;

export default TRANSACTION_TYPES_FRAGMENT;
